import axios from 'axios';
import toast from 'react-hot-toast';
import { useMutation, useQuery } from 'react-query';
import Account from '../types/account';
import { Organization } from '../types/organization';
import StageAccess from '../types/stage-access';
import { ACCESS_ALL_URL, ACCESS_URL, BASE_URL, ORGANIZATION_URL, PROCESS_URL } from './urls';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {}
});

apiClient.interceptors.request.use(function (config) {
  if (config.headers) config.headers.authorization = localStorage.getItem('AUTH_TOKEN') ?? '';
  return config;
});

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      localStorage.clear()
      // toast.error('نشست کاری شما به اتمام رسید، لطفا دوباره وارد شوید')
      setTimeout(() => { window.location.href = '/login' }
        , 2000)

    }
  })

export const useGetAllProcesses = () => {
  return useQuery(
    'processes',
    async () => {
      const res = await apiClient.get(PROCESS_URL);
      return res.data;
    },
    {}
  );
};

export const useGetProcess = (processId?: string) => {
  return useQuery(
    'process-' + processId,
    async () => {
      const res = await apiClient.get(PROCESS_URL + processId);
      return res.data;
    },
    {}
  );
};

export const useGetUserProcessAccess = (processId?: string) => {
  return useQuery(
    'access-' + processId,
    async () => {
      const res = await apiClient.get(ACCESS_URL(processId ?? ''));
      return res.data;
    },
    {}
  );
};

export const useGetAllProcessAccess = (processId?: string) => {
  return useQuery<{ id: string, title: string, accounts: Account[], accesses: StageAccess[] }[]>(
    'accesses-' + processId,
    async () => {
      const res = await apiClient.get(ACCESS_ALL_URL(processId ?? ''));
      return res.data;
    },
    {}
  );
};

export const useGetOrganizations = (processId?: string) => {
  return useQuery<{ organization: Organization; count: number }[]>(
    'organizations-' + processId,
    async () => {
      const res = await apiClient.get(ORGANIZATION_URL);
      return res.data;
    },
    {}
  );
};

export function useCreateProcess() {
  return useMutation(
    ({
      number,
      organization,
      weight,
      performaNumber,
      orderNumber,
      description
    }: {
      number?: string;
      organization?: string;
      description?: string;
      weight?: string;
      performaNumber?: string;
      orderNumber?: string;
    }) =>
      apiClient.post(PROCESS_URL, {
        number,
        organization,
        weight,
        performaNumber,
        orderNumber,
        description
      })
  );
}
